import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'pq-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false,
})
export class LoginComponent {
  isLoading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async login() {
    this.isLoading = true;
    try {
      await this.authService.login(); // Redirects to Okta
    } catch (error) {
      console.error('Login error:', error);
      this.isLoading = false;
    }
  }
}
